<div class="tw-flex tw-flex-col">
  <label class="tw-font-medium" id="view-mode-label">View Mode</label>
  <mat-button-toggle-group
    aria-labelledby="view-mode-label"
    (valueChange)="toggleListView($event)"
    name="list-view-toggle"
    [(ngModel)]="value"
    [hideSingleSelectionIndicator]="true"
  >
    <mat-button-toggle
      id="listViewSelector"
      title="List view"
      value="list"
      aria-label="Toggle list view"
    >
      <mat-icon svgIcon="list-view" />
    </mat-button-toggle>
    <mat-button-toggle
      id="gridViewSelector"
      title="Grid view"
      value="grid"
      aria-label="Toggle grid view"
    >
      <mat-icon svgIcon="grid-view" />
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>
